
































import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import { ISourceType } from '@/store/tool/imgcolor/types';

@Component
export default class ToolImgColorUpload extends Vue {
  @Prop() public source!: ISourceType;
  @Prop() public loading!: boolean;

  public params: FormData | null = null;

  public urlRule(v: string) {
    return /^(https?:\/\/).+$/.test(v) || '必须以 http:// 或 https:// 开头';
  }

  // 上传本地图片
  public onFileChange(file?: File) {
    this.setParams(1, file);
  }

  // 网络图片
  public onUrlChange(url?: string) {
    this.setParams(2, url);
  }

  public setParams(type: ISourceType, value?: File | string) {
    if (!value) {
      this.params = null;
      return;
    }

    const formData = new FormData();

    // 本地图片
    if (type === 1) {
      formData.append('source', 'file');
      formData.append('uploadFile', value);
      formData.delete('url');
    }

    // 网络图片
    if (type === 2) {
      formData.append('source', 'url');
      formData.append('url', value);
      formData.delete('uploadFile');
    }

    this.params = formData;
  }

  @Emit('upload')
  public onSubmit() {
    return this.params;
  }

  // 切换图片源时，禁用上传按钮
  @Watch('source')
  public typeChange() {
    this.params = null;
  }
}
